import $ from 'jquery';
import Backbone from 'backbone';
import bizzaboAjax from './bizzaboAjax';

// Backbone 1.1.2's UMD reads jQuery from the global `root`, which under
// rspack/webpack is the module scope (not window), so Backbone.$ ends up
// undefined and View.setElement throws. Wire it explicitly. This runs first
// (autoImport) in every entry, before any View is created.
Backbone.$ = $;
Backbone.ajax = bizzaboAjax;
// module.exports = Backbone;
